export const VENDOR_MODAL_W = 800
export const VENDOR_MODAL_H = 850
